import { request } from '../../../utils/request';

export default async function submitIndividualBVN(
  customerId: number,
  bvn: string,
  authToken: string
): Promise<{
  success: boolean;
  message: string;
  status: 'verified' | 'rejected';
}> {
  const res = await request({
    url: '/sterling/kyc/submit/bvn',
    method: 'POST',
    formData: { customer_id: customerId, bvn },
    headers: { Authorization: `Bearer ${authToken}` },
  });

  if (!res.success) throw new Error(res.message);
  return res;
}
